import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { SpinnerComponent } from '../spinner/spinner.component';
import { Icons } from '../../../shared/helpers/icons';
import { ALERT_CATEGORY_MAP, ALERT_TYPES, ResponseCode } from '../../../shared/models/alert.model';
import { AlertLog, AlertUserStatus } from '../../../shared/services/lockdown-user.service';

@Component({
  selector: 'app-alert-statuses-modal',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, SpinnerComponent],
  templateUrl: './alert-statuses-modal.component.html'
})
export class AlertStatusesModalComponent {
  @Input() alert!: AlertLog;
  @Input() statuses: AlertUserStatus[] = [];
  @Input() loading = false;
  @Output() closed = new EventEmitter<void>();

  icons = Icons;

  alertTypeName(typeId: number): string {
    return ALERT_TYPES[typeId] ?? 'Unknown';
  }

  alertTypeClass(typeId: number): string {
    const category = ALERT_CATEGORY_MAP[typeId] ?? 'lockdown';
    switch (category) {
      case 'lockdown':       return 'bg-red-100 text-red-600';
      case 'fire':           return 'bg-orange-100 text-orange-600';
      case 'police':         return 'bg-blue-100 text-blue-600';
      case 'medical':        return 'bg-green-100 text-green-600';
      case 'administrative': return 'bg-purple-100 text-purple-600';
      default:               return 'bg-gray-100 text-gray-600';
    }
  }

  responseClass(code: ResponseCode): string {
    switch (code) {
      case 1: return 'bg-green-100 text-green-600';
      case 2: return 'bg-amber-100 text-amber-600';
      case 3: return 'bg-blue-100 text-blue-600';
      case 4: return 'bg-red-100 text-red-600';
      default: return 'bg-gray-100 text-gray-600';
    }
  }
}
